import { Link2, LogOut } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

// iter 178k: Sales Rep can't access the main app. This is what they see
// after logging in — a hint that they should open the share link that
// was sent to them by admin.
export default function SalesRepHomePage() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try { await logout(); } catch (_) {}
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-6" data-testid="sales-rep-home">
      <div className="max-w-md text-center bg-white border border-gray-200 rounded-2xl p-8 shadow-sm">
        <div className="w-14 h-14 rounded-2xl bg-amber-100 text-amber-700 flex items-center justify-center mx-auto mb-4">
          <Link2 size={26} strokeWidth={1.75} />
        </div>
        <h1 className="text-lg font-semibold text-gray-900 mb-1">Welcome, {user?.name || user?.email}</h1>
        <p className="text-sm text-gray-500 mb-6">
          You're signed in as a <span className="font-medium text-gray-700">Sales Rep</span>.
          Open the product share link that was sent to you to select products and generate customer-specific quote links.
        </p>
        <div className="text-xs text-gray-400 leading-relaxed mb-6">
          The share link looks like <span className="font-mono text-gray-600">/share/products/&lt;token&gt;</span>.
          Paste it into your browser's address bar or click the link in the message you received.
        </div>
        <button
          data-testid="sales-rep-logout"
          onClick={handleLogout}
          className="inline-flex items-center gap-2 text-xs font-medium text-gray-500 hover:text-gray-700"
        >
          <LogOut size={13} strokeWidth={1.75} /> Sign out
        </button>
      </div>
    </div>
  );
}
